export default "__VITE_ASSET__Kde5psMK__"